import { Button, Typography } from "@mui/material";

export default function UnauthorizedPage() {
  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <div>
        <Typography component="p" paragraph>
          ページを表示する権限がありません。
        </Typography>
        <Typography component="p" paragraph>
          下記ボタンから一度ログアウトし、再度アクセスしてください。
        </Typography>
        <Button
          component="a"
          href="/.auth/logout"
          variant="contained"
          sx={{ marginLeft: "1rem" }}
        >
          ログアウト
        </Button>
      </div>
    </div>
  );
}
